/* unplugin-vue-components disabled */import script from "./xToolbar.vue?vue&type=script&setup=true&lang=js"
export * from "./xToolbar.vue?vue&type=script&setup=true&lang=js"

import "./xToolbar.vue?vue&type=style&index=0&id=31c247c8&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-31c247c8"]])

export default __exports__